import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import ErrorBoundary from '../../../../common/ErrorBoundary'
import { TableSkeleton } from '../../../../common/Skeletons'
import InfoBox from '../../../../common/InfoBox'
import ExportChartDataToExcel from '../../../../common/ExportChartDataToExcel'
import { formatNumber, getDDMMYYYYHHmmToIST } from '../../../../helpers/UtilityHelper'
import { BarChart } from '../../../charts/BarChart'
import { ACCENT } from '../../../charts/colors'
import useFakeData from './useFakeData'
import FakeDeliveryTable from './FakeDeliveryTable'

function FakeComponent() {
    const {
        filteredData, dataGroupedByCourierOrMerchant, dataGroupedByPaymentMode,
        isLoading, totalFake, fakeWhatsApp, fakeTelecalling
    } = useFakeData()

    const downloadOptions = [
        {
            label: 'Download Fake Deliveries',
            fileName: 'FAKE_DELIVERIES',
            data: filteredData || [],
            columns: [
                { label: 'AWB Number', value: 'awbNumber' },
                { label: 'Courier', value: 'courierName' },
                { label: 'Status', value: 'orderStatus' },
                { label: 'Pickup Pincode', value: 'pickupPincode' },
                { label: 'Drop Pincode', value: 'dropPincode' },
                { label: 'Invoice Value', value: 'invoiceValue' },
                { label: 'Payment Mode', value: 'paymentMode' },
                { label: 'Order Date', value: (row) => getDDMMYYYYHHmmToIST(row.awbRegisteredDate) },
            ]
        }
    ]

    const courierChartOptions = {
        xaxis: 'name',
        data: [{ dataKey: 'count', label: 'Count', fill: ACCENT.red }],
    }

    const paymentChartOptions = {
        xaxis: 'name',
        data: [{ dataKey: 'count', label: 'Count', fill: ACCENT.blue }],
    }

    return (
        <Accordion expanded>
            <AccordionSummary sx={{ boxShadow: 1, borderRadius: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 600 }}>Fake Deliveries</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ExportChartDataToExcel options={downloadOptions} />
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: '0.7rem', color: 'text.secondary', mt: 0.5 }}>
                        Shipments flagged as fake deliveries by courier partners. Includes WhatsApp and telecalling conversation history.
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#f5f8fa', px: 0 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        {isLoading && <TableSkeleton rows={10} />}
                        {!isLoading && (
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <InfoBox header="Total Fake Deliveries" value={formatNumber(totalFake)} />
                                </Grid>
                                <Grid item xs={4}>
                                    <InfoBox header="WhatsApp Conversations" value={formatNumber(fakeWhatsApp)} />
                                </Grid>
                                <Grid item xs={4}>
                                    <InfoBox header="Telecalling Conversations" value={formatNumber(fakeTelecalling)} />
                                </Grid>
                                {dataGroupedByCourierOrMerchant?.length > 0 && (
                                    <Grid item xs={12} md={6}>
                                        <Card elevation={1}>
                                            <CardHeader
                                                title="Courier Wise Split"
                                                subheader="Fake deliveries by courier partner"
                                            />
                                            <CardContent>
                                                <BarChart data={dataGroupedByCourierOrMerchant} chartOptions={courierChartOptions} />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )}
                                {dataGroupedByPaymentMode?.length > 0 && (
                                    <Grid item xs={12} md={6}>
                                        <Card elevation={1}>
                                            <CardHeader
                                                title="Payment Mode Split"
                                                subheader="Fake deliveries by payment mode"
                                            />
                                            <CardContent>
                                                <BarChart data={dataGroupedByPaymentMode} chartOptions={paymentChartOptions} />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <FakeDeliveryTable data={filteredData} />
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default function Fake() {
    return (
        <ErrorBoundary>
            <FakeComponent />
        </ErrorBoundary>
    )
}
